import React from "react";
import { Controller } from "react-hook-form";
import { Box, InputAdornment, TextField } from "@mui/material";
import PhotoUpload from "../../../components/PhotoUpload/PhotoUpload";
import { EquipmentDataCreate } from "../../../types/api/equipment";
import { CreateFormProps } from "../../../types/common";
import { MoneyField } from "../../../components/UI/MoneyField/MoneyField";

const CreateContent = ({ createForm }: CreateFormProps<EquipmentDataCreate>) => {
    return (
        <Box
            component="form"
            sx={{
                "& .MuiTextField-root": { my: 1 },
            }}
            noValidate
            autoComplete="off">
            <Controller
                defaultValue={""}
                name="name"
                control={createForm.control}
                rules={{
                    required: true,
                    maxLength: {
                        value: 120,
                        message: "Максимальная длина 120 символов",
                    },
                }}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        fullWidth
                        label={"Наименование"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="start_date"
                control={createForm.control}
                rules={{ required: true }}
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label="Ввод в эксплуатацию"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                defaultValue={""}
                name="date"
                control={createForm.control}
                rules={{ required: true }}
                render={({ field: { onChange, value, ...field }, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                        label="Дата выпуска"
                        onChange={(e: any) => {
                            onChange(e.target.value.replace(/-/g, "/"));
                        }}
                        value={value?.replace(/\//g, "-")}
                        autoComplete="off"
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <Controller
                name="count"
                control={createForm.control}
                rules={{ required: true }}
                render={({ field, fieldState }) => (
                    <TextField
                        {...field}
                        size={"small"}
                        fullWidth
                        label={"Кол-во"}
                        type={"number"}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">ед.</InputAdornment>,
                        }}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />
            <MoneyField name={"cost"} control={createForm.control} label={"Закупочная стоимость"} />
            <Controller
                name="photos"
                control={createForm.control}
                rules={{ required: true }}
                render={({ field: { value }, fieldState, formState: { errors } }) => {
                    return (
                        <PhotoUpload
                            formError={errors?.photos?.type === "required"}
                            error={fieldState.error}
                            field={{ photos: value }}
                            setValue={createForm.setValue}
                        />
                    );
                }}
            />
        </Box>
    );
};

export default CreateContent;
